import { useParams } from 'react-router-dom';
import { PlaylistAssignPanel } from '../features/playlistAssignments';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignPlaylist = () => {
  const {
    playlistId
  } = useParams();
  return /*#__PURE__*/_jsx(PlaylistAssignPanel, {
    playlistId: Number(playlistId)
  });
};
export default AssignPlaylist;